function AdminSchoolsLocationsController($state) {}
AdminSchoolsLocationsController.$inject = ["$state"];
export default AdminSchoolsLocationsController;

